export const AGENT_ROUTE_NAMES = {
  TICKET_LIST: 'TicketList',
  CASE_PROCESSING: 'CaseProcessing',
  CUSTOMER_NEW: 'CustomerNew',
  COMPANY_NEW: 'CompanyNew',
  COMPANY_VIEW: 'CompanyView',
  CASE_ACCESS_DENIED: 'CaseAccessDenied',
} as const
